<template>
  <div class="wp-card" :class="{ 'wp-card--danger': enrollment.failing }">
    <div class="wp-card__head">
      <div class="min-w-0">
        <div class="wp-card__eyebrow">{{ enrollment.typeLabel }}</div>
        <h3 class="wp-card__title">{{ enrollment.title }}</h3>
        <div v-if="note" class="wp-card__who">{{ note }}</div>
        <!-- A past enrollment: when it ended, and why ("Jun 30, 2025 · after failed payments") -->
        <div v-if="enrollment.endedNote" class="wp-card__who">{{ enrollment.endedNote }}</div>
      </div>
      <span v-if="enrollment.badge" class="charge-badge" :class="`charge-badge--${enrollment.badge.tone}`">{{ enrollment.badge.text }}</span>
    </div>

    <div v-if="enrollment.progress" class="wp-progress">
      <div class="wp-progress__labels">
        <span><span class="font-semi">{{ enrollment.progress.paid }}</span> <span class="wp-muted">of {{ enrollment.progress.total }}</span></span>
        <span class="wp-muted">{{ enrollment.progress.label }}</span>
      </div>
      <div class="wp-progress__track">
        <div class="wp-progress__bar" :style="{ width: `${enrollment.progress.percent}%` }"></div>
      </div>
    </div>

    <dl v-if="enrollment.facts.length > 0 || enrollment.insurance.length > 0" class="wp-facts">
      <div v-for="fact in enrollment.facts" :key="fact.label" :class="{ 'wp-fact--wide': fact.wide }">
        <dt>{{ fact.label }}</dt>
        <dd v-if="fact.coupon" class="wp-fact__coupon"><coupon-pill :code="fact.coupon.code"></coupon-pill><span v-if="fact.coupon.detail" class="wp-muted">{{ fact.coupon.detail }}</span></dd>
        <dd v-else>{{ fact.value }}</dd>
      </div>
      <div v-if="enrollment.insurance.length > 0" class="wp-fact--wide">
        <dt>Insurance</dt>
        <dd v-for="policy in enrollment.insurance" :key="policy.key" class="wp-insurance">
          <span>{{ policy.text }}</span>
          <span class="charge-badge" :class="`charge-badge--${policy.badge.tone}`">{{ policy.badge.text }}</span>
        </dd>
      </div>
    </dl>

    <div v-if="enrollment.link" class="wp-card__footer">
      <a :href="enrollment.link.href" class="btn btn-default btn-compact">{{ enrollment.link.text }}</a>
    </div>
  </div>
</template>
<script>
import CouponPill from './coupon_pill.vue';

// One enrollment (subscription, registration, or a session's drop in / trial
// purchases) on the wrestler Payments tab. wrestler_payments.vue builds the
// view model; this only lays it out.
export default {
  name: 'wrestler-enrollment-card',
  components: { CouponPill },
  props: {
    enrollment: { type: Object, required: true },
    // e.g. "Shared with Talia Fer" on a parent's page
    note: { type: String, default: null },
  },
};
</script>
